var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('div',{staticClass:"head_title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }